import { render, staticRenderFns } from "./GreenOperationPreviewBody.vue?vue&type=template&id=14207d34&scoped=true&"
import script from "./GreenOperationPreviewBody.vue?vue&type=script&lang=js&"
export * from "./GreenOperationPreviewBody.vue?vue&type=script&lang=js&"
import style0 from "./GreenOperationPreviewBody.vue?vue&type=style&index=0&id=14207d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14207d34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14207d34')) {
      api.createRecord('14207d34', component.options)
    } else {
      api.reload('14207d34', component.options)
    }
    module.hot.accept("./GreenOperationPreviewBody.vue?vue&type=template&id=14207d34&scoped=true&", function () {
      api.rerender('14207d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/letters/GreenOperationPreviewBody.vue"
export default component.exports